var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeavyPlus = function SvgHeavyPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3432 17.6867H48V30.6024H30.3432V48H17.6568V30.6024H0V17.6867H17.6568V0H30.3432V17.6867Z",
    fill: "#9974F6"
  })));
};
export { SvgHeavyPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMwLjM0MzIgMTcuNjg2N0g0OFYzMC42MDI0SDMwLjM0MzJWNDhIMTcuNjU2OFYzMC42MDI0SDBWMTcuNjg2N0gxNy42NTY4VjBIMzAuMzQzMlYxNy42ODY3WiIgZmlsbD0iIzk5NzRGNiIvPgo8L3N2Zz4K";